import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import utils from '../../utils';
import paymentsService from '../../services/PaymentServices';
import { useAuth } from '../../context/UserContext';
import adminServices from '../../services/AdminServices';
import vendorServices from '../../services/VendorSevices';
import moment from 'moment';
import { FaCheck, FaX } from 'react-icons/fa6';

function RefundModal({ action, activeRefund, cartItem, onSubmitSuccess }) {
    const [description, setDescription] = useState('');
    const [resolutionNotes, setResolutionNotes] = useState('')
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef(null);
    const { user } = useAuth();
    const [isResolved, setIsResolved] = useState(false)
    const [isSuccessfull, setIsSuccessfull] = useState(false)

    useEffect(() => {
        if (action === 1 && activeRefund) {
            setDescription(activeRefund.description || '');
            setIsResolved(activeRefund?.is_resolved)
            setResolutionNotes(activeRefund?.resolution_notes || '')
            setIsSuccessfull(activeRefund?.is_successfull)
        } else {
            setDescription('');
            setImage(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }, [action, activeRefund]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file && !file.type.startsWith('image/')) {
            toast.error('Please select a valid image file (JPEG, PNG, etc.)');
            event.target.value = '';
            return;
        }
        setImage(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (action === 1) {
            if (user?.is_vendor && activeRefund?.is_resolved) {
                toast.error('You cannot update a resolved refund.')
                return
            }
        }
        const closeBtn = document.getElementById('refund-modal-close-btn');

        if (action === 0 && !cartItem) {
            toast.error('Cart item is missing.');
            return;
        }

        setLoading(true);
        const formData = new FormData();
        formData.append('description', description);

        if (image) {
            formData.append('image', image);
        }
        if (action === 0) {
            formData.append('cart_item', cartItem.id);
            formData.append('owner', user?.id);
        }
        if (action === 1) {
            if (resolutionNotes) {
                formData.append('resolution_notes', resolutionNotes);
            }
            formData.append('is_resolved', isResolved)
            formData.append('is_successfull', isSuccessfull)
            formData.append('resolved_by', user?.id)
        }

        try {
            let response;
            if (action === 0) {
                response = await paymentsService.createRefund(formData);
                toast.success('Refund request submitted successfully!');
            } else {
                response = user?.is_admin
                    ?
                    adminServices.updateRefund(activeRefund?.id, formData)
                    :
                    vendorServices.updateRefund(activeRefund?.id, formData)
            }
            console.log(response);

            setLoading(false);
            if (onSubmitSuccess) onSubmitSuccess();
            closeBtn.click();
        } catch (err) {
            console.error(err);
            toast.error(utils.toastError || 'Failed to process refund request.');
            setLoading(false);
        }
    };

    const clearInput = () => {
        setDescription('');
        setImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setIsResolved(false)
        setResolutionNotes('')
    };

    return (
        <div>
            <label htmlFor="refund-modal" id="refund-open-btn" className="hidden">
                Request Refund
            </label>
            <input type="checkbox" id="refund-modal" className="modal-toggle" />
            <div className="modal">
                <div className="modal-box w-11/12 max-w-2xl">
                    <label
                        onClick={clearInput}
                        htmlFor="refund-modal"
                        id="refund-modal-close-btn"
                        className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2"
                    >
                        ✕
                    </label>
                    <h2 className="text-lg font-bold mb-4">
                        {action === 1 ? 'Refund Details' : 'Request a Refund'}
                    </h2>

                    {action === 1 && activeRefund?.image && (
                        <div className="flex justify-center mb-4">
                            <a
                                href={activeRefund.image}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block"
                            >
                                <img
                                    src={activeRefund.image}
                                    alt="Refund proof"
                                    className="rounded-md max-h-60 object-contain hover:cursor-pointer"
                                />
                            </a>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        {(action === 1 || cartItem) && (
                            <div className="mb-4 p-3 bg-base-200 rounded-md ">
                                <div className="flex flex-col md:flex-row gap-3">
                                    <div className="">
                                        <p className="font-medium">
                                            {action === 1
                                                ? activeRefund?.cart_item?.product?.name
                                                : cartItem?.product?.name}
                                        </p>
                                        <p className="text-sm text-gray-500">
                                            {action === 1
                                                ? `Ordered on: ${new Date(activeRefund?.creation_time).toLocaleDateString()}`
                                                : 'You are requesting a refund for this item.'}
                                        </p>
                                    </div>
                                    <div>
                                        {activeRefund?.cart_item?.product?.store_name && (
                                            <p>
                                                <strong className='mr-2'>Store:</strong>
                                                <span className='text-gray-500'>
                                                    {activeRefund?.cart_item?.product?.store_name}
                                                </span>
                                            </p>
                                        )}
                                        {cartItem?.product?.store_name && (
                                            <p>
                                                <strong className='mr-2'>Store:</strong>
                                                <span className='text-gray-500'>
                                                    {cartItem?.product?.store_name}
                                                </span>
                                            </p>
                                        )}
                                        <p>
                                            <strong className='mr-2'>Quantity:</strong>
                                            <span className='text-gray-500'>
                                                {
                                                    action === 1
                                                    ? activeRefund?.cart_item?.quantity 
                                                    : cartItem?.quantity
                                                }
                                            </span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <strong className='mr-2'>Total:</strong>
                                            <span className='text-gray-500 mr-2'>
                                                {action === 1
                                                    ?
                                                    utils.toCommas(activeRefund?.cart_item?.total || 0)
                                                    : utils.toCommas(cartItem?.total || 0)
                                                }

                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Description */}
                        <div className="form-control mb-3">
                            <label className="label">
                                <span className="label-text">Reason for Refund:</span>
                            </label>
                            <textarea
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required
                                disabled={action === 1}
                                placeholder="E.g., Wrong item received, damaged product, etc."
                                className="textarea textarea-bordered w-full"
                                rows="2"
                            />
                        </div>

                        {action === 0 && (
                            <div className="form-control w-full mb-3">
                                <label className="label">
                                    <span className="label-text">
                                        Proof (Photo/Receipt): {action === 0 && '*'}
                                    </span>
                                </label>
                                <input
                                    ref={fileInputRef}
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    className="file-input file-input-bordered w-full"
                                    required={action === 0}
                                />
                            </div>
                        )}
                        {(action === 1 && (user?.is_admin || user?.is_vendor)) && (
                            <>
                                <div className="form-control mb-3">
                                    <label className="label">
                                        <span className="label-text">Resolution Notes:</span>
                                    </label>
                                    <textarea
                                        value={resolutionNotes}
                                        onChange={(e) => setResolutionNotes(e.target.value)}
                                        required
                                        disabled={action === 0}
                                        placeholder="E.g. Replaced damaged product, etc."
                                        className="textarea textarea-bordered w-full"
                                        rows="2"
                                    />
                                </div>
                                <div className='mb-3 flex gap-3'>
                                    <div>
                                        <label className="label">
                                            <span className="label-text">Is Resolved:</span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={isResolved}
                                            onChange={(e) => setIsResolved(e.target.checked)} />
                                    </div>
                                    <div>
                                        <label className="label">
                                            <span className="label-text">Is Successfull:</span>
                                        </label>
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={isSuccessfull}
                                            onChange={(e) => setIsSuccessfull(e.target.checked)} />
                                    </div>
                                </div>
                            </>
                        )}


                        {(action === 1 && (user?.is_admin || user?.is_vendor)) ? (
                            <div className="mt-6">
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-red-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                                >
                                    {loading ? (
                                        <span>{action === 0 ? 'Submitting...' : 'Updating...'}</span>
                                    ) : (
                                        <span>{action === 0 ? 'Submit Refund Request' : 'Update Details'}</span>
                                    )}
                                </button>
                            </div>
                        ) : (
                            <div>

                            </div>
                        )}

                    </form>

                    {/* View-only info for existing refunds */}
                    {action === 1 && (
                        <div className="mt-6 pt-4 border-t border-base-300">
                            <div className="space-y-2 text-sm">
                                <div>
                                    <span className="font-bold mr-2">Status:</span>{' '}
                                    <span className={activeRefund?.is_resolved ? 'text-green-600' : 'text-yellow-600'}>
                                        {activeRefund?.is_resolved ? 'Resolved' : 'Pending'}
                                    </span>
                                </div>
                                {activeRefund?.resolution_notes && (
                                    <div>
                                        <span className="font-bold mr-2">Resolution Notes:</span>{' '}
                                        <span>{activeRefund.resolution_notes}</span>
                                    </div>
                                )}
                                <div className='flex items-center'>
                                    <span className="font-bold mr-2">Is Successfull:</span>{' '}
                                    <span>
                                        {activeRefund?.is_successfull ? (
                                            <FaCheck />
                                        ) : (
                                            <FaX />
                                        )}
                                    </span>
                                </div>
                                {activeRefund?.resolved_by && (
                                    <div>
                                        <span className="font-bold mr-2">Handled by:</span>{' '}
                                        <span>{activeRefund.resolved_by.email}</span>
                                    </div>
                                )}
                                <div>
                                    <span className="font-bold mr-2">Created On:</span>
                                    <span>{moment(activeRefund?.creation_time).format('lll')}</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default RefundModal;